import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup, ReactiveFormsModule} from '@angular/forms';
import {HideOnBlurDirective} from '../../../../_directives/hide-on-blur.directive';
import {NgxMaskModule} from 'ngx-mask';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../../../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-hawk-sin-dob',
    templateUrl: './hawk-sin-dob.component.html',
    styleUrls: ['./hawk-sin-dob.component.scss'],
    imports: [ReactiveFormsModule, HideOnBlurDirective, NgxMaskModule, ValidationErrorsComponent_1, TranslateModule]
})
export class HawkSinDobComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() sinControlName: string = 'sin';
  @Input() dobControlName: string = 'dob';

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  @Input() displayErrors: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
